import type { EventParams } from '@alice-health/observability/src/lib/types'

import { hasCookieConsent } from '@/global/hooks/useCookieConsent/hasCookieConsent'
import { observability } from '@/global/plugins/observability/observability.setup'

import { getUtmsFromQuery } from '../query-params'
import { EventName } from './types/common'
import { DispatchEventOptions, DispatchEventProperties } from './types/types'

const PASSIVE_EVENTS: EventName[] = [
  EventName.PAGE_VIEWED,
  EventName.SECTION_VIEWED
]

export const dispatchEvent = (
  { eventName, ...rest }: DispatchEventProperties,
  options?: DispatchEventOptions
) => {
  if (options?.consentCategory && !hasCookieConsent(options.consentCategory))
    return

  observability?.log(
    eventName,
    {
      value: {
        ...rest,
        ...getGlobalProps()
      }
    } as EventParams,
    {
      providers: ['EVENT_API'],
      isAction: !PASSIVE_EVENTS.includes(eventName)
    }
  )
}

const getGlobalProps = () => {
  const utms = getUtms()
  const platform = getPlatform()
  const pagePath = window !== undefined ? window.location.pathname : null

  return {
    platform,
    pagePath,
    ...utms
  }
}

const getUtms = () => {
  const queryString = window !== undefined ? window.location.search : ''
  const searchParams = new URLSearchParams(queryString)
  const query = Object.fromEntries(searchParams.entries())

  return query ? getUtmsFromQuery(query) : {}
}

const getPlatform = () => {
  if (typeof window === 'undefined') return ''
  if (window.innerWidth < 768) return 'web_mobile'
  if (window.innerWidth >= 768 && window.innerWidth < 1366) return 'web_tablet'
  return 'web_desktop'
}
